import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';
import Stack from '@mui/material/Stack';

// TODO add color to library
const hoverBg = '#EBF6F7';

export const sxStyles = {
  infographicContainer: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.625rem 1.25rem',
    color: theme.palette.common.black,
  }),
  schoolTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginBottom: '0.5rem',
  }),
  favorite: {
    height: '50px',
    width: '50%',
    transition: 'background-color 0.5s',
  },
};

export const StyledReducedSchoolCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isFluid',
})<{ isFluid?: boolean }>(({ theme, isFluid }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: isFluid ? '100%' : '296px',
  maxWidth: '296px',
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderTop: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '0 0 4px 4px',
}));

export const StyledSchoolPhoto = styled('div')(() => ({
  position: 'relative',
  height: '184px',
  width: '100%',

  '& > img:first-of-type': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

export const StyledSchoolDetailsContainer = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'space-between',
  padding: '1.5rem 1.25rem 0.75rem',
  minHeight: '120px',
}));

export const StyledNotes = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '32px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '2px',
  position: 'absolute',
  bottom: '1rem',
  left: '1rem',

  ':hover': {
    cursor: 'pointer',
    backgroundColor: hoverBg,
  },
}));

// The auto margin takes the container's free space, so the badge stays under the title and the address stays at the bottom
export const StyledUtahBadgeContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingBottom: theme.spacing(2),
  marginBottom: 'auto',
}));

export const StyledAddressContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'flex-start',
  width: 'fit-content',

  '& > div:first-of-type': {
    marginRight: '0.5rem',
  },
}));

export const StyledActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  width: 'calc(100% - 2.5rem)',
  minHeight: '74px',
  margin: '0 1.25rem ',
  borderTop: `1px solid ${theme.palette.grey['300']}`,

  '&:before': {
    content: '""',
    position: 'absolute',
    height: '50px',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1px',
    backgroundColor: theme.palette.grey['300'],
  },
}));

export const StyledMoreLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  width: '50%',
  fontWeight: 600,
  color: theme.palette.primary.main,
  transition: 'background-color 0.5s',

  '& > svg:first-of-type': {
    marginLeft: '1rem',
    fill: theme.palette.primary.main,
  },

  ':hover': {
    backgroundColor: hoverBg,
  },
}));

export const StyledDistance = styled(CoreTypography)({
  flexShrink: 0,
  whiteSpace: 'pre',
});
